"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _moment = _interopRequireDefault(require("moment"));

var _Title = _interopRequireDefault(require("../Title/Title"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _icons = require("@ant-design/icons");

require("./TrackComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TrackComponent = function TrackComponent(_ref) {
  var setShowTrack = _ref.setShowTrack,
      trackCloseIcon = _ref.trackCloseIcon,
      trackList = _ref.trackList;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var requestStatus = {
    0: "Pending",
    1: "Approved",
    2: "Deleted",
    3: "Declined",
    4: "Submitted"
  };

  var trackCloseHandler = function trackCloseHandler() {
    setShowTrack(false);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "track-container"
  }, trackList === null || trackList === void 0 ? void 0 : trackList.map(function (track, index, arr) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "track-item track-".concat(requestStatus[track.req_status])
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "track-left"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "track-header "
    }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
      className: "track-title label-bold"
    }, track === null || track === void 0 ? void 0 : track.message), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      className: "track-tag track-tag-".concat(requestStatus[track.req_status], " label-graph")
    }, requestStatus["".concat(track.req_status)])), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      className: "track-name label-regular"
    }, track.req_to && track.req_to.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, track.req_status === 1 ? "".concat(track.approved_by || "-", " to ").concat(track.req_to) : "".concat(track.created_by || "-", " to ").concat(track.req_to)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, track.req_status === 1 ? "".concat(track.approved_by || "-") : "".concat(track.created_by || "-", " "))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      className: "label-graph"
    }, track.req_status === 1 ? "".concat((0, _moment["default"])(track === null || track === void 0 ? void 0 : track.approved_at).format("D MMM YYYY, hh:mm:ss"), " ").concat(t("common.hrs")) : "".concat((0, _moment["default"])(track === null || track === void 0 ? void 0 : track.created_at).format("D MMM YYYY, hh:mm:ss"), " ").concat(t("common.hrs")))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "track-right"
    }, index + 1 !== arr.length && /*#__PURE__*/_react["default"].createElement(_icons.RightOutlined, {
      className: "next-step-icon"
    })));
  }), trackCloseIcon && /*#__PURE__*/_react["default"].createElement(_icons.CloseOutlined, {
    className: "close-icon",
    onClick: trackCloseHandler
  }));
};

var _default = TrackComponent;
exports["default"] = _default;